import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { SpoTrainPluginService } from './spo-train-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
  selector: 'spo-train-edit',
  templateUrl: './spo-train-edit.component.html',
  standalone: false
})
export class SpoTrainPluginPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public spoLockings: any[];
  averageOs: number;
  averageOos: number;
  averageGap: number;
  public initialSpoLockings: any;
  public processing = false;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private service: SpoTrainPluginService,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service
      .updateSpoLocking(this.inspectionId, this.pointId, this.pluginId, {
        SpoLockings: this.spoLockings,
        AverageOs: this.averageOs,
        AverageOos: this.averageOos,
        Gap: this.averageGap
      })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.spoLockings = this.plugin.config.SpoLockings.map((x: any) => Object.assign({}, x));
      this.averageOs = this.plugin.config.AverageOs;
      this.averageOos = this.plugin.config.AverageOos;
      this.averageGap = this.plugin.config.Gap;
      if (!this.spoLockings || this.spoLockings.length === 0) {
        this.spoLockings = [];
        let initialLenght = 1;
        while (initialLenght < 7) {
          this.spoLockings.push({ Id: initialLenght });
          initialLenght++;
        }
      }
      this.cdRef.detectChanges();
    });
  }

  add() {
    const id = Math.max(...this.spoLockings.map((l) => l.Id)) + 1;
    this.spoLockings.push({ Id: id });
    this.calculate();
  }

  remove(id: number) {
    this.spoLockings = this.spoLockings.filter((l) => l.Id !== id);
    this.spoLockings.forEach((value, i) => {
      value.Id = i + 1;
    });
    this.calculate();
  }

  calculate() {
    const length = this.spoLockings.length;
    this.averageOs = this.osAverage;
    this.averageOos = this.oosAverage;
    this.averageGap = this.gap;
    if (length < 2) return;
    this.spoLockings.forEach((l, i) => {
      const prev = this.spoLockings[(i - 1 + length) % length];
      l.OsGap = (l.Os ?? 0) - (prev.Os ?? 0);
      l.OosGap = (l.Oos ?? 0) - (prev.Oos ?? 0);
    });
  }

  get osAverage() {
    if (!this.spoLockings.length) return null;
    const osSum = this.spoLockings.reduce((sum, l) => sum + (l.Os ?? 0), 0);
    return osSum / this.spoLockings.length;
  }

  get oosAverage() {
    if (!this.spoLockings.length) return null;
    const osSum = this.spoLockings.reduce((sum, l) => sum + (l.Oos ?? 0), 0);
    return osSum / this.spoLockings.length;
  }

  get gap() {
    return this.oosAverage - this.osAverage;
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'editjson']);
  }

  gotoEditPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'edit']);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  goToNext(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.focus();
      return;
    }
    this.add();
    setTimeout(() => this.goToNext(id));
  }
}
